var isSingleItem = function isSingleItem(item) {
  return !Array.isArray(item);
};
export { isSingleItem };